// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ILimitedUsePeriodDto } from './ILimitedUsePeriodDto';
import {
    ILimitedUsePeriodDtoFromJSON,
    ILimitedUsePeriodDtoFromJSONTyped,
    ILimitedUsePeriodDtoToJSON,
    ILimitedUsePeriodDtoToJSONTyped,
} from './ILimitedUsePeriodDto';

/**
 * 
 * @export
 * @interface ICoveragePeriodDto
 */
export interface ICoveragePeriodDto {
    /**
     * 
     * @type {Date}
     * @memberof ICoveragePeriodDto
     */
    coverage_date_start?: Date;
    /**
     * 
     * @type {Date}
     * @memberof ICoveragePeriodDto
     */
    coverage_date_end?: Date;
    /**
     * 
     * @type {Array<ILimitedUsePeriodDto>}
     * @memberof ICoveragePeriodDto
     */
    limited_periods?: Array<ILimitedUsePeriodDto>;
}

/**
 * Check if a given object implements the ICoveragePeriodDto interface.
 */
export function instanceOfICoveragePeriodDto(value: object): value is ICoveragePeriodDto {
    return true;
}

export function ICoveragePeriodDtoFromJSON(json: any): ICoveragePeriodDto {
    return ICoveragePeriodDtoFromJSONTyped(json, false);
}

export function ICoveragePeriodDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICoveragePeriodDto {
    if (json == null) {
        return json;
    }
    return {
        
        'coverage_date_start': json['coverage_date_start'] == null ? undefined : (new Date(json['coverage_date_start'])),
        'coverage_date_end': json['coverage_date_end'] == null ? undefined : (new Date(json['coverage_date_end'])),
        'limited_periods': json['limited_periods'] == null ? undefined : ((json['limited_periods'] as Array<any>).map(ILimitedUsePeriodDtoFromJSON)),
    };
}

export function ICoveragePeriodDtoToJSON(json: any): ICoveragePeriodDto {
    return ICoveragePeriodDtoToJSONTyped(json, false);
}

export function ICoveragePeriodDtoToJSONTyped(value?: ICoveragePeriodDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'coverage_date_start': value['coverage_date_start'] == null ? undefined : ((value['coverage_date_start']).toISOString().substring(0,10)),
        'coverage_date_end': value['coverage_date_end'] == null ? undefined : ((value['coverage_date_end']).toISOString().substring(0,10)),
        'limited_periods': value['limited_periods'] == null ? undefined : ((value['limited_periods'] as Array<any>).map(ILimitedUsePeriodDtoToJSON)),
    };
}

